// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"393":"1927037b","656":"6a20fa19"}[chunkId] + ".css";
};